import { useState, useEffect, useCallback } from 'react';
import { ProductWithCalculations } from '../types/inventory';
import { fetchPedidoSugerido } from '../../services/sellersApi';

export const useProducts = () => {
  const [products, setProducts] = useState<ProductWithCalculations[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadProducts = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchPedidoSugerido();
      setProducts(data);
    } catch (err: any) {
      setError(err?.message || 'Erro ao carregar produtos');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadProducts();
  }, [loadProducts]);

  return { products, loading, error, refetch: loadProducts };
};
